export enum ChargingPointStatusEnum {
  Unregistered = 1,
  Available = 2,
  Charging = 3,
  Faulted = 4,
  Finishing = 5,
  Preparing = 6,
  Reserved = 7,
  SuspendedEV = 8,
  SuspendedEVSE = 9,
  Unavailable = 10,
  Offline = 11
}